import React from 'react';

function ExternalError() {
	return (
		<div id='externalError'>
			<div id='externalError_wrapper'>
				SOMETHING WENT WRONG, <br /> PLEASE RELOAD THE PAGE
			</div>
		</div>
	);
}

export default React.memo(ExternalError);
